export default{
  "home": {
    "p2": "홈",
    "p3": "캐릭터",
    "p4": "뉴스",
    "p5": "대회",
    "p6": "스페셜",
    "p7": "패산 생성 방법 공개",
    "p8": "언어",
    "p9": "헬프",
    "p10": "전체",
    "p11": "공지",
    "p12": "공식대회",
    "p13": "기타",
    "p14": "스토리",
    "p15": "너, 마작하면 어떤 이미지가 떠올라?\n도박, 밤샘, 담배연기, 오래된 게임?\n확실히, 마작에 대한 대중의 인식에는 아직 편견이 있긴 해.\n그렇지만 시대가 변하면서 사람들의 인식도 변하고 있지.\n「마작은 스포츠성과 오락성이 있는 지적 활동이다.」\n근래에는 다양한 마작 대회・영상작품 등이 연이어 등장하면서「프로 작사가 될거야!」라는 꿈을 갖는 사람도 늘고 있어.\n그리고 마작 경기가 발전하는 와중에, 「마작일번가」라고 하는 상점가는 글로벌 작사들의 성지가 되었지.\n그곳에는 마작을 사랑하는 사람들이 모여있어.",
    "p16": "캐릭터 일람",
    "p17": "쿠키 렌신",
    "p18": "오싹오싹 광전사",
    "p19": "CV 아라이 사토미",
    "p20": "학생시절에는 자주 게임센터에 잠입해서 마작을 했다. 무엇이든지 내기하려는 경향이 있어서, 라멘을 먹을때도 먹는 시간이 홀수인지 짝수인지 내기할 정도였다. 졸업 후, 세계일주가 하고 싶다는 이유만으로 국경없는 의사회에 들어갔고, 그 후 어느 의사를 따라 일번시의 병원에 취직했다. 낮에는 존재감이 없지만 일이 끝나면 디스코댄스나 갬블에 일편단심으로 푹 빠졌다. 하지만 점점 갬블에 대한 흥미가 사라지고, 다양한 마작사들에게 도전하고 싶게 되어 마작일번가에 오게되었다.",
    "p21": "개인 정보보호 정책",
    "p22": "이용규약",
    "p23": "면책사항",
    "p24": "부정행위에 대하여",
    "p25": "메뉴",
    "p26": "커뮤니티",
    "p27": "기프트 수령",
    "p28": "세트구매",
    "p31": "구입",
    "p32": "세일"
  },
  "about": {
    "p2": "헬프",
    "p3": "문의사항, 의견, 희망사항 등은 아래에 기재된 곳으로 연락 바랍니다.",
    "p4": "Twitter: @mahjongpet",
    "p5": "E-mail：riichicitysupport@mahjong-jp.com"
  },
  "disclaimer": {
    "p2": "면책사항",
    "p3": "본 게임의 아이템은, 불환 지폐나 그 외의 현실 세계의 가치와의 교환 또는 양도가 불가능합니다. 본 플랫폼에서의 플레이는 오락 목적뿐으로, 현금이나 그 외의 현실 세계의 가치를 어떠한 형태로든 획득하거나 인출하는 것은 불가능합니다.\n\n「마작일번가」는 사기행위에는 엄정하게 대처합니다. 사기적인 지불 방법으로 게임 아이템을 구입하려 하거나 한다면, 현지의 자금 세탁 방지법이나 규제를 위반할 가능성이 있습니다.「마작일번가」는 IP 주소, 이름, 채팅 로그를 포함한(이것들만에 한하지 않습니다.) 고객으로부터 수집한 정보를 넘겨줌과 동시에 관련된 지역 당국에 통보하는 법적 의무를 지게 되는 경우가 있습니다.\n\n게임을 플레이하는 것은 오락의 일종입니다만, 중독성도 있습니다. 저희는 고객의 유저로서의 경험이 가능한 한 좋게 되기를 바라고 있기 때문에, 책임감을 갖고 플레이해주시기 바랍니다."
  },
  "legal3": {
    "p2": "부정행위에 대하여",
    "p3": "「마작일번가」는「짜고치기」나 기타 부정행위에 엄정하게 대처합니다.\n\n명백하게 부정한 동탁률이 검출된 경우, 또는 부정행위가 확인된 경우, 성적의 삭제, 계정의 이용금지나 삭제를 시행하는 경우도 있으므로 미리 양해 바랍니다.\n\n의심스러운 플레이를 발견하신 분은 {href} 에 알려주십시오. 아래에 기재된 정보를 제공해 주신다면 저희 회사 소정의 절차에 의거하여 신속하게 대응하도록 하겠습니다.\n\n・부정을 저지른 유저의 이름\n\n・관련 대국의 패보 URL\n\n앞으로도「마작일번가」를 잘 부탁드립니다."
  },
  "character": {
    "p2": "여류작사",
    "p3": "잇시키 세이비",
    "p4": "반짝반짝 일색애호가",
    "p5": "CV 오구라 유이",
    "p6": "어릴 때는 양친과 해외에 거주했었다. 가족마작으로 룰을 배워가며 마작을 시작했다. 작탁 위에서는 일반인을 아득히 뛰어넘는 운을 발휘. 지금까지와는 다른 즐거움을 찾기 위해, 마작강자들이 많이 모이는 마작일번가에 왔다. 꿈은 프로 마작사가 되는 것과 세계대회에 참가하는 것.",
    "p7": "미야케 칸나",
    "p8": "절대작감 Dreamer",
    "p9": "CV 아라이 사토미",
    "p10": "어린시절을 양친과 떨어져서 홀로 보냈다. 가장 좋아하는 이웃 언니에게 어린이용 마작셋트를 받은 것을 계기로, 마작을 좋아하게 되었다. 혼자서 4인분의 역할을 연기하면서 마작을 두고, 그 이야기를 소설로 써서 인터넷에 발표하여 단번에 명성을 날리게 되었다. 인터넷 게시판에서 마작일번가의 존재를 알게되어, 마작 세계를 연구하기 위해 왔다. 현재는 마작사들 기묘한 과거를 취재하여, 소설가로서의 독특한 감성으로 과장되게 자신의 작품을 쓰고있다.",
    "p11": "토호 나기",
    "p12": "일격의 숙녀",
    "p13": "CV 오구라 유이",
    "p14": "가족은 지역최대의 마장을 경영하고 있다. 한때는 양친이 마장 경영으로 바빠져서, 마작을 싫어하던 시기도 있었다. 하지만 어느날 우연히 인터넷에서, 프로 마작사인 아버지가 출전한 시합을 보았고, 그 빛나는 모습에 매료되었다. 그리하여 아버지처럼 프로 마작사가 되겠다는 꿈이 생기게 되었다. 본격적으로 마작을 하기 시작한 그녀는 공전절후의 재능을 뽐내며, 지역의 유명 마작사가 되었다. 하지만 최근에는 수수께끼의 슬럼프에 빠져 부진한 나날이 이어지게 되었고, 현재는 마작일번가의 마장에서 자신의 마작 감각을 되찾으려 힘쓰고 있다.",
    "p15": "이가라시 사에코",
    "p16": "읽기의 달인",
    "p17": "CV 하세가와 레나",
    "p18": "어린 시절에는 양친이 대화해주지 않아서, 고독한 생활을 하고 있었다. 항상 티비를 보고 지내던 도중, 사람들의 움직임이나 표정에서 그 진의를 읽는 능력을 얻게되었다. 마음을 읽는 것이 특기인 그녀는, 티비에서 본 마작패의 무늬나 소리에 끌려서, 인생을 마작에 바칠 것을 결심했다. 술을 가장 좋아해서, 일번가에서는 「비밀을 교환하는」바를 운영하고 있다. 모든 마작사들의 비밀을 알고있기에, 그녀는 일번가를 좌지우지하는 「수수께끼의 존재」즉 보스라고 하는 소문도 있다. 지금의 단계에서, 진실은 아직 밝혀져있지 않다.",
    "p19": "쿠키 렌신",
    "p20": "오싹오싹 광전사",
    "p21": "CV 아라이 사토미",
    "p22": "학생시절에는 자주 게임센터에 잠입해서 마작을 했다. 무엇이든지 내기하려는 경향이 있어서, 라멘을 먹을때도 먹는 시간이 홀수인지 짝수인지 내기할 정도였다. 졸업 후, 세계일주가 하고 싶다는 이유만으로 국경없는 의사회에 들어갔고, 그 후 어느 의사를 따라 일번시의 병원에 취직했다. 낮에는 존재감이 없지만 일이 끝나면 디스코댄스나 갬블에 일편단심으로 푹 빠졌다. 하지만 점점 갬블에 대한 흥미가 사라지고, 다양한 마작사들에게 도전하고 싶게 되어 마작일번가에 오게되었다.",
    "p23": "아마미 시오츠키",
    "p24": "디지털 구도자",
    "p25": "CV 하세가와 레나",
    "p26": "디지털 구도자 겸 학교의 학생회장. 어린 시절, 수학교사인 할아버지로부터 「마작은 사고력을 높여준다」라는 말을 듣게되어 마작을 시작했다. 처음에는 데이터대로 확실한 수순에 따라 마작을 쳤지만 곧바로 정체기에 빠지게 되었다. 선배와 함께 패보를 분석하던 중, 자신의 미스가 타인의 판단을 좌우하는 상황도 있었다는 것을 눈치채고, 버림패 읽기의 의표를 찌는 스타일을 단련했다. 그 후, 더욱 강해지기 위해 마장에서 아르바이트를 하기에 이르렀다. 데이터 마작의 어려움을 느끼게 된 그녀는, 강자와 만나 디지털파의 한계를 돌파하는 것을 목표로 일번가에 왔다. 그녀가 치또이츠를 좋아하는 이유는 패산 읽기, 상대방 읽기, 스지 대기 등과 같은 전술을 활용할 수 있기 때문이다.",
    "p27": "남성작사",
    "p28": "텐미야 켄이치",
    "p29": "괴짜 왕자",
    "p30": "CV 모리시마 슈타",
    "p31": "말하는 방식이 경박하다. 매번 반드시 말하는 대사는 「텐파이 달성 직후 리치 선언, 단기대기는 왕도, 노미는 필살기」. 학생시절에는 동급생의 영향으로 마작의 룰을 알게되어, 그 후 인터넷 마작에 푹 빠져 「마작일번가」라는 인터넷 게임의 탑 플레이어가 되었다. 일번가에 숨어있는 「수수께끼의 존재」의 정체가 궁금해서 아르바이트 명목으로 일번가에 왔다. 그는 조금씩 단서를 얻어서 바 오너 이가라시 사에코를 의심하기 시작했다. 진상을 찾아보던 중에 그녀로부터 영향을 받게되어 프로 마작사를 목표로 하게 되었다.",
    "p32": "쟝마루",
    "p33": "사천의 후로 마스터",
    "p34": "CV 모리시마 슈타",
    "p35": "사천성의 후로 마스터. 중국 사천 출신의 팬더로, 사천마작을 시작하여, 각종 중국 마작의 룰에 정통하다. 일본의 마작사들과 교류하기 위해 마작일번가에 왔다. 사천마작의 영향으로 초공격형이 된 그였지만, 일본식 마작을 통해, 수비의 오의를 공부하고 싶다고 생각하고 있다. 일본식 마작에 푹 빠져있지만, 일본어를 그렇게까지 잘하지는 못한다.",
    "p36": "사오토메 유리카",
    "p37": "엔젤 멜로디",
    "p38": "CV 이시카와 유이",
    "p39": "5살 연상의 오빠와 둘이서 살고 있다. 눈은 보이지 않지만 여러 가지 장식에 관심이 있어서 주변 사람들에게 배색을 묻는 것을 가장 좋아한다.\n어렸을 적에 눈병을 앓아서, 거의 대부분의 시간을 병원에서 보냈다. 양친은 그녀의 병을 치료하기 위해 갖가지 수단을 써봤지만, 성과를 내지 못하고 지쳐버려서 결국에는 그녀가 7살일 때 치료를 포기하였고, 유리카를 돌보지 않게 되었다.\n오빠에게 걱정을 끼치지 않기 위해 항상 웃는 얼굴을 하고 있지만, 마음속에서는 눈이 보이지 않는 것이나 친구가 없는 것에 괴로워하여, 홀로 있을 때는 눈물을 흘린다.\n촉각을 단련하기 위해 오빠인 나오야로부터 마작의 무늬를 배웠고, 만져서 무늬를 알아낼 수 있도록 훈련했다. 유리카가 최초로 만진 마작패는 일삭으로, 마음속에서 무늬를 본 듯한 기묘한 감각을 느끼게 되었고, 이내 마작을 좋아하게 되었다.\n눈은 보이지 않지만 청각이 뛰어나서 탁월한 음악적 재능의 소유자이기도 하다. 그녀가 연주하는 음악에는 듣는 사람에게 용기를 주는 힘이 있다. 그 힘을 병으로 괴로워하는 사람을 돕기위해 쓰고싶다고 생각하여, 병원에서 아르바이트를 하고 있다. 그 일을 하던 와중에 쿠키와 당신을 만나게 되었다.",
    "p40": "아카바네 아테나",
    "p41": "절대정의 발키리",
    "p42": "CV 이시카와 유이",
    "p43": "경찰관으로서 일번가의 안전을 지킨다. 언제나 상사로부터「경찰관답게 하고 다녀」라고 주의받지만, 전혀 고칠 생각이 없다. 신체능력이 뛰어나고 일번가의 불량배들이 두려워한다.\n아버지는 FBI의 수사관으로, 그녀를 데리고 외근할 때도 있었다. 그 덕분에 그녀는 세계 속 여러 사람들의 고통과 죄악을 알 수 있게 되었다. 언뜻 보면 자유분방에 기가 쎄고 난폭한 느낌도 들지만, 마음씨 착한 일면도 있다. 그녀의 소원은 잘못된 범죄의 길로 빠져버린 소년소녀 모두를 구하는 것.\n예전에 임무 중 한번 부상을 입게 되어 쿠키 렌신에게 간호 받은 적이 있다. 쿠키 렌신이 위법적인 치료행위를 하고 있지는 않을까 하고 의심하여 자주 그녀와 충돌한다. 하지만 실제로는 쿠키를 신경 쓰고 있고, 와일드한 성격 탓에 위험에 휘말리지는 않을까 하고 걱정하고 있다. 쿠키가 디스코 댄스를 출 때도 항상 따라간 적이 있다. 그 후, 쿠키를 따라 마장에 가게 되었고 마작을 좋아하게 되었다.",
    "p44": "나츠우미 마린",
    "p45": "백수의 여왕",
    "p46": "CV：스구타 히나",
    "p47": "일번가에서 가장 유명한 미용사로 여러가지 형태를 만드는 것을 잘한다. 청순가련한 모습은 많은 사람들의 이목을 끈다. 성격은 겉모습과 다르게 음흉한 면이 있다. 또한, 미용을 좋아해서 헤어 메이크를 특기로 하고 있는데, 사실 손님의 머리를 자유롭게 조절하는 것이 가능한 컨트롤 감을 좋아한다.\n창의적인 것을 좋아해서 마작을 할 때도 상상력이 풍부한 조합으로 신기한 일격을 먹이는 경우가 있다. 또한, 마작칠 때의 진퇴가 예리하고, 타패가 빠르기 때문에 「작탁의 호랑이」라고 자칭하고 있다. 점수를 컨트롤하는게 능숙하다.\n사오토메 나오야와는 다른 작사가 헤어 스타일을 정리하러 오는 것으로 아는 사이가 되었다. 많은 사람을 컨트롤 할 수 있지만, 사오토메 나오야는 컨트롤 할 수 없었던 것에서, 그를 좋아하게 되었다. 나츠우미 마린은 정말로 좋아하는 사람이 생기면 연애 밖에 생각할 수 없게 된다.",
    "p48": "사오토메 나오야",
    "p49": "버닝 피스트",
    "p50": "CV 나미카와 다이스케",
    "p51": "사오토메 유리카의 형. 유리카는 태어날 때부터 맹인이었지만, 나오야는 그녀가 꼭 나을 것이라고 믿고 있다.\n둘은 어릴 적에 양친에게 버려지게 되어, 생계를 꾸리기 위해 여러가지 일을 해왔다. 동생의 병을 치료하기 위해, 더욱 많은 돈을 벌기 위해 복싱을 시작했다.\n원래는 자상하고 내향적인 성격이었지만, 갖가지 고생을 한 경험으로, 여동생 이외의 사람에게는 차갑게 대하고 거리를 두려한다. 여동생의 앞에서는 항상 상냥하고, 웃는 얼굴을 보여준다. 또한 「여동생을 지키지 않으면 안돼」라는 중압감이 그의 원동력이 되고 있지만, 마음 속 깊은 곳에는 약한 일면도 갖고 있다.\n눈이 보이지 않는 여동생의 촉각을 발달시키기 위해, 마작패를 만지는 연습을 같이 하고 있었다.\n복싱을 할때는 주먹을 계속 내질러 공격 일변도 이지만, 마작을 칠때는 냉정한 일면을 보인다.",
    "p52": "후카세 아리스",
    "p53": "Tactics Goddess",
    "p54": "CV：누마쿠라 마나미",
    "p55": "대형 재단・후카세의 아가씨. 학생이면서 사교의 장에 얼굴을 드러내고 있으며, 재단의 비지니스에도 깊이 관여하고 있다. 자신만만한 두뇌파. 가족의 힘을 빌리는 것을 좋아하지 않아서, 자신의 손으로 문제를 해결하고자 하는 신념이 있다. \n메니야(부하이자 스파이）는 천화시(天和市)의 일번가에서 일을 하고 있다. 메니야의 보고에 의해 마작일번가에 흥미를 갖게 되어, 이곳에 방문하게 되었다. 마작을 시작한 이래로 일주일만에 프로자격을 획득하였고, 경기 마작 팀「산즈(三途) 인터스트리」에 들어갔다. 너무나도 빠져드는 모습에, 세간으로부터 「후카세 가의 마작 중독 아가씨」라는 소리가 점점 들려오고 있다. \n전술 구사를 좋아하여, 자신의 타법을 「아리스의 절묘전술」이라고 부른다. 일번가에서 「월간 평균 순위 2.1」을 목표로 하고 있지만, 지금은 목표까지 멀다고 한다. \n무엇이든 요령 좋게 구사하는 그녀가 유일하게 어려워 하는 것은 요리 만들기. 왜인지 레시피 대로 만들어도 암흑색의 요리가 완성되지만, 그래도 계속해서 시도하고 있다. 「후카세 아리스는 결점 따위 없어요, 뭐든지 완벽합니다!」",
    "p56": "메니야",
    "p57": "침묵의 집행자",
    "p58": "CV 유우키 아오이",
    "p59": "일번 빌즈의 양복점에서 점원을 하고 있지만, 그 정체는 후카세 재단이 일번가에 파견한 스파이. 주민과의 대화로부터 일번가의 비밀을 캐내고, 후카세 아리스가 비지니스에서 유리한 위치에 서도록 하기위해 움직이고 있다.\n스파이로서는 유능하지만 점원으로서의 일은 미숙하여, 문 앞에서 「어서오세요」라고 말하는 것 밖에 할게 없다. 스타일은 발군으로 동경의 대상이 되었지만, 멍-하니 있으면서 말주변이 없는 면도 있다.\n최근에는 더욱 많은 정보를 모으기 위해 일번가의 마장에 가서, 보통은 접할 일 없는 사람들을 관찰하고 있다.\n싫어하는 일이 있어도 참기 때문에 오해 받기 쉽지만, 소문에 의하면 이전에 엮인 적이 있던 불량배 10명을 가게 밖으로 던져버린 적도 있다. 그녀는 소문이라고 주장하고 있지만, 진실은 당사자만이 알고있는 듯 하다.\n궁핍하여 길거리를 헤매고 있던 때, 후카세 아리스에게 거두어져, 이후에는 그녀의 곁에서 시중을 들고 있다. 이 두명이 만났을 때, 아리스는 메니야의 눈에서 깊은 어둠을 보았지만, 그래도 그녀에게 손을 내밀어 주었다. 메니야는 과거의 경험으로 아리스를 경계했지만, 그 눈에서 공포심이 사라진 순간, 둘의 사이에는 침묵의 계약이 상호 전달되게 되었다.",
    "p60": "AU.RO.RA",
    "p61": "영생의 흡혈희",
    "p62": "CV 오오니시 사오리",
    "p63": "고등학생처럼 보이지만, 사실은 자신이 기억하는 것보다 훨씬 긴 세월을 살아가고 있다. 「뱀파이어」 중 희소종인, 「데이워커」로서 낮에 모습을 드러내는 것이 가능하지만, 순혈종의 데이워커는 아니기에, 낮에 이동하려면 특수한 호흡기가 필요. 타인에게 위해를 가하지 않기 위한 호흡기와, 자제력을 잃지 않기 위해 손을 구속하는 끈을 달고 있다. 또한, 자신을 잃지 않기 위해, 매일 스트랩으로 묶여있다. 매일 주간에는 자신이 누구인지 잊어버렸다가, 밤이되면 기억이 돌아오는 희귀한 기억상실 증상에 빠져있다. \n긴 세월을 살아온 탓에, 친구가 없다. 일번가에서 지내던 그녀는 마작할 하면 건망증이 낫는다는 소문을 믿고, 오랫동안 마작을 쳐와서, 그것이 유일한 취미가 되었다. 최근에는 매일 밤 토호가의 마장에 다니면서 마작을 치고 있다. 또한, 흡혈하지 않아도 되지않을까 하고, 언제나 적도라가 있는 마작을 하며 기분을 달래고 있다. 다양한 노력을 하여, 언젠가는 태양빛 속을 자유롭게 걸어다니고, 흡혈하지 않는 흡혈귀가 되고 싶다고 바라고 있다.",
    "p64": "후지 잇키",
    "p65": "미숙한 점술사",
    "p66": "CV 스기야마 노리아키",
    "p67": "자칭 미야케 칸나의 소설 속 캐릭터. 미야케의 소설 설정에 불만이 있어, 현실세계에 등장해서 불만을 말할 수 있게 되었다고 한다. 미야케의 소설「일기통관의 용맹한 소년」의 주인공「우사기 지로」와 성격이 완전히 똑같아서, 일부 아이들은 그가 정말로 소설로부터 나온 인물이라고 믿고있다.\n실제로는 미야케 칸나의 사촌으로, 소설 주인공의 모델이 되었다. 후지 잇키는 소설가「미야케 우사기」의 왕팬이지만, 처음에는 그녀의 정체를 몰랐다. 그는 어느 날 우연히, 미야케의 집에서 소설의 손으로 쓴 원고를 발견하였고, 미야케 칸나가 미야케 우사기라고 하는 것을 알게 되어, 미야케의 뒤를 쫓아 천화시에 왔다.\n우사기 지로는 미야케의 소설 속에서 게으르게 생활하며 사람을 속이는「자칭 점술사」. 더욱 능숙하게「우사기 지로」를 연기하기 위해, 후지 잇키는 자주 일번가의 다양한 사람들에게「당신의 운명을 알려주지」라고 말하며, 누구라도 맞출 수 있는 말을 그럴 듯하게 말하고 다닌다. 마작을 하기 전에도 자신의 운세를 점쳐서,「이제부터 5반장의 순위는 1-1-2-2-1이야」등을 말한다. 그의 예언은 절반은 빗나가지만, 신기하게도 남은 절반은 딱 들어 맞는다.",
    "p68": "시라하 아스카",
    "p69": "금빛 눈동자의 마녀",
    "p70": "CV 우치다 마아야",
    "p71": "수수께끼의 중2병 소녀. 언제나 No.001 마크가 있는 팔찌를 차고 있다. 색이 다른 오른쪽 눈동자는「모든 것을 꿰뚫어 보는」능력이 있다고 자칭하는, 팀 Dawn 운명기사의 에이스 플레이어이다.\n시라하 아스카는 대회전에는 주목 받지 않았던 신참. 천하일번상의 오러스에서는 마지막 순서였지만, 사암각단기 대사희자일색으로 화료하여 시합을 지켜보던 전세계 사람들을 열광의 도가니에 몰아넣었다.\n그 후, 시라하 아스카는 탁월한 힘을 발휘하며, 천하일번상에서 가장 주목받는 이변요소가 되었고, 팀 Dawn운명기사는 팀 황제와 동격의 우승후보로 예상되게 되었다.\n하지만 결승전 날, 만화카페에서 신간 잡지를 읽으며 자버린 통에, 눈을 떴을 땐 대회종료 2시간 후 였다. 시라하의 천하일번상에의 여정은 이런 형태로 끝맺음 되었다.\n그 후, 기자의 취재에 응한 그녀는, 가슴을 감싸고, 얼굴을 찌뿌린 채, 「이것이 바로 운명의 기사로서 짊어지는 짐이다. 하지만, 나는 결고 굴하지 않을 거야. 언젠가 그 오만한 신의 앞에 서서, 인간이라도 세계 제일의 강자가 될 수 있다는 걸 가르쳐 주지!」라고, 매우 괴로운 듯이 말했다고 한다.",
    "p72": "하라 미치유키",
    "p73": "무쌍의 검사",
    "p74": "CV 유카나",
    "p75": "미치유키는 고아였을 적, 도장의 스승에게 거두어져, 철이 들 무렵부터 스승에 검술을 사사받았다.\n스승이 미덥지 않았기 때문일까, 미치유키는 어릴적부터 스스로 자립하기 시작하였고, 자칭「작검쌍절」의 스승은 매일 도장에서 연습을 지도하는 것 외에, 미치유키를 데리고 마작을 하였다. 도장의 관리는 일찍부터 미치유키에게 맡겨졌다.\n검술에 능할 뿐만 아니라, 고운 용모자태와 예의 바름을 갖춘 그녀는 마을에서 유명인이 되었다. 다만, 스승과 같이 검술과 마작 외의 취미는 없는 듯 하다.\n낮에는 검술을 익히고, 밤에는 마작을 하는 나날이 이어졌지만, 18세가 되던 날「졸업이다! 이제 도장은 너에게 맡긴다. 유키쨩 힘내라!」라고 써진 메모를 남기고, 스승은 자취를 감추었다.\n어안이 벙벙한 상황에서 미치유키는 어느 날 거리의 가게를 지나가던 때, 티비에서 본 적이 있는 얼굴을 보고 놀랐다. 그 당시, 화면에는 중요한 마작시합의 중계가 이어지고 있었고, 거기에서「천하일번상」이라고 하는 글귀가 하라미치의 눈에 들어왔다...",
    "p76": "오토나시 이쿠코",
    "p77": "멘헤라 버츄얼 스트리머",
    "p78": "CV 유카나",
    "p79": "넷 마작에 특화된 실력파 버튜버. 사립 귀족 중학 슈오학원의 재학생. 그녀는 부모님의 소망을 받아들여 노력한 끝에, 슈오학원에 입학할 수 있었지만, 생각한 만큼의 화려한 인생은 아니라는 것에 눈치 챈다. 그녀는 어디를 가도 배경의 조용한 나무와 같이 존재감이 옅었다.\n항상 어두운 오라를 풍기는 그녀는, 인터넷 상에서 자신의 있어야 할 곳을 발견했다. 엶은 화면 속에서 이쿠코는 버튜버「음속 나나코」로 변신한다. 그 세계에서만, 그녀는 밝고 정열적인 캐릭터가 될 수 있었다. 그녀는 화제성이 높은「온라인 마작」을 활동영역으로 하여, 단기간에 랭킹 상위까지 올라가게 되었다. 수많은 프로작사들을 쓰러뜨리면서, 수수께끼의 넷마작 마스터로서의 전설이 시작되었다.\n버츄얼 세계에서 성적을 내는 것만으로는 만족하지 못하여, 현실 세계의 프로 마작에도 주목하기 시작했고 그곳에서 유명해지면 더욱 인기가 오를지도...? 라는 생각을 품고, 이쿠코는 프로 작사로의 길을 걷기 시작했다.",
    "p80": "에노미야 미오",
    "p81": "백흑세계의 고아",
    "p82": "CV 유우키 아오이",
    "p83": "야오츄가에서 온 야생견. 어릴 적에는 양친에 의해 야오츄가라고 하는 슬럼가에 버려졌다. 원래는 아름다운 흑발이었지만, 야오츄가의 아이들이「이런 아름다운 머리칼은 야생견인 네녀석에게 어울리지 않아.」라는 말을 하면서 하얀 페인트를 그녀의 머리에 뒤집어 썼다. 이 사건으로 시력이 낮아지게 되었고, 집에서 거울에 비친 자신의 모습을 보면서 이 굴욕을 잊지 않기 위해, 머리 색을 백흑의 스타일로 하게 되었다.\n뒷세계 마장에서 놀고 있던 아저씨가 미오를 보곤, 그녀에게 마작의 재능이나 강한 관찰력과 계산력이 있다는 것을 알아채었고, 그녀를 키워왔다. 그녀의 재능으로 돈벌이를 하자고 생각하여 다양한 마작 기술을 가르쳤다. 시간이 흐르면서 마장에서 수입을 얻고 있던 그녀는, 아저씨가 자신을 돈벌이의 도구로 생각하고 있다는 것을 알면서도 있을 곳을 마련해 준 아저씨에게 감사하며 생활하고 있었다. 어느 날, 아저씨가 갬블에서 졌을 때, 미오를 담보로 하려고 하였다. 그것을 눈치 채고 환멸한 그녀는 슬럼가로부터 도망쳐 나왔다.\n그 때, 자신에게는 마작 밖에 없다는 것을 느끼고 마작일번가에 향하여 토호 마장의 멤버가 되었다. 그녀의 재능은 점점 주목받게 되었고, 토호 마장에 협력하는 프로작사가 되었다. 그녀의 인생은 지금부터 새로운 페이지를 넘기게 되었다.",
    "p84": "코쿠라 카나데",
    "p85": "유행을 추구하는 자",
    "p86": "CV 스구타 히나",
    "p87": "유행을 추구하는 자. 수앵학원의 품행이 단정한 학생들 입장에서 보면, 코쿠라 카나데는 이세계의 존재이다. 그들은 그녀가 왜 여기에 있는지를 이해하지 못하고, 그쪽의 세계로 들어갈 수도 없으므로, 그녀에 대한 소문에서 미약하나마 단서를 얻을 수밖에 없었다. 그러므로 그녀에 대해서는 [불량소녀]라는 왜곡된 이미지가 생기게 되었다.\n코쿠라 카나데에 관한 소문에는 본인조차 놀랄 만한 것이 많다. 하지만 그녀는 항상 패션의 유행에만 주목하다 보니 자신의 소문에 대해 꼬치꼬치 캐묻는 일은 거의 없다. 유행이란 순식간에 지나가는 법. 코쿠라 카나데에게 그런 덧없는 빛남을 추구하는 것만큼 중요하고 시급한 것은 없다. 설령 그것을 위해 답답한 교칙을 어겨야만 한다고 해도. 혜성이 지구의 인력을 신경 쓰지 않듯이 그녀는 그런 것에 신경쓰지 않는 것이다.\n팀 성신은 이런 빛나는 여고생을 곧바로 눈여겨보고 제안을 내놓았고, 그녀는 기꺼이 그 제안을 받아들였다. 자신이 마작을 하는 모습이나 화료하는 모습을 SNS에 올리고, 좋아요와 댓글 수가 기세좋게 늘어나는 것을 보는 것은, 그녀의 즐거움 중 하나다. 하지만 동시에 그녀는 한 가지 고민을 안고 있다. 그것은 멋지게 화료하는 빈도가 그리 높지 않았고, 찍은 사진에 [빛남]이 부족하다는 것이었다. 어떻게 하면 마작실력을 높일 수 있을까. 그것이 지금의 그녀에게 있어서의 최우선 과제이다.",
    "p88": "후와 마히루",
    "p89": "승리를 쫓는 왕녀",
    "p90": "CV 나츠요시 유우코",
    "p91": "승리를 쫓는 용감한 왕녀, 늠름한 높은 산의 꽃. \n중앙작원 선대 원장의 손녀인 후와 마히루는, 열다섯 살에 처음 프로작사로 경기장에 등장한 이래 마작계 전체의 주목을 받고 있다. 그의 커리어 데뷔는 틀림없이 훌륭했고, 첫 경기에서 놀라운 침착성과 임기응변의 대응을 보이며 파죽지세로 개인전에서 1위를 차지했다. 같은 해 팀 제황에 가담한 후와 마히루는 천하일번상에 출전하여 결승전에서 전설의 작시 료세이 쿠로에게 고전 끝에 승리하여 팀이 삼도인더스트리를 타도, 우승하는 데 기여하였다. 이후 후와 마히루의 이름은 널리 알려졌고, 료세이 쿠로와 시키부 키미히토의 잇따른 은퇴는, 새로운 왕의 대관의 장대한 개막을 알렸다. 이듬해 후와 마히루는 팀 제황과 함께 다시 천하일번상에 출진했다. 신진기예 다운나이츠 오브 데스티니를 꺾고 우승의 영관을 지킨 지금, 전인미답의 3연패는 이 천재 소녀의 목전에 있다. \n많은 기자들은 후와 마히루에게 비즈니스 기회가 있다는 것을 알아챘지만, 마작 외의 그녀의 생활은 거의 백지 상태이다. 기자들이 아무리 조사해도 그녀의 취미나 스캔들, 논란을 일으킬 만한 발언은 일절 발견되지 않았다. 그녀의 눈에는 마작밖에 비치지 않는 것 같다.",
    "p92": "이누카이 히나",
    "p93": "질서의 대리인",
    "p94": "CV 나츠요시 유우코",
    "p95": "질서의 대리인, 부드러운 미소의 악마. \n지금은 작구학원의 이사장으로 알려진 이누카이 히나이지만 학원을 졸업하기 전에 중앙작원으로부터의 내부 평가에서 S급 예비 채용생 중 한 명으로 인정받은 사실은 그다지 알려져 있지 않다. 졸업식이 끝난 후, 그녀의 우편함으로 중앙작원에서 온 축하와 초대장이 도착했다. 테스트 불필요, 학비 전액면제, 간단한 조건을 충족하면 거액의 장학금을 받을 수 있음. 이것이 중앙작원이 자신만만하게 그녀에게 내놓은 조건이었다. \n중앙작원이 제공하는 이 정도의 우대를 거부하는 마작 애호가는 거의 없다. 이것이 마작 천재인 이누카이 히나가 한때 경험했던, 남들이 부러워하는 인생이었지만, 그녀는 최종적으로는 평범하고, 더 곤란할 수도 있는 길을 선택했다. 그것은, 날이 갈수록 쇠퇴해 가는 작구학원의 부흥을 목표로 하는 것이었다. 이를 위해 그는 천화대학에 입학신청을 하였고, 매니지먼트와 교육학 두 가지를 전공한 뒤 졸업 후에는 모교로 돌아와 취직하게 되었다. \n지금 이누카이 히나는 작구팀에 들어가 마작의 삶을 재개했다. 데뷔 이래 그녀는 여러 경기에서 훌륭한 기술을 보여주며 천화의 작사들이 갖고 있는 천재소녀에 대한 기억을 다시금 불러일으켰다.",
    "p96": "타치바나 카오루",
    "p97": "치유계 아이돌",
    "p98": "CV 우에무라 유우토",
    "p99": "착하고 밝은 후진형 아이돌. 별의 소년 3기 그룹이 첫 라이브에 출연했을 때, 타치바나 카오루는 팬인 친구와 함께 우연히 무대를 멀리서 보고 있었을 뿐이었다. 그 우연하고 놀라운 만남이 이후 타치바나 카오루의 인생을 바꿔놓았다.\n타치바나 카오루는 클래식 음악의 명가 출신으로, 부모는 유명인사였고 형은 바이올린계의 샛별로 주목받았다. 역시 비범한 음악적 재능을 가진 타치바나 카오루는 생각 끝에 가족과는 다른 길--아이돌이 되겠다고 다짐한다.\n그때까지 기초가 없었던 타치바나 카오루는 단기간에 훌륭한 춤 기술을 익혔고, 거의 완벽한 노랫소리는 어떤 노래도 그의 입에서 뛰어나게 잘 지어진 시가와 같이 들리게 되었다. 때마침 3기 그룹 중 한 명이었던 치바 하루키가 탈퇴하고, 4기 예비역 지원 중인 타치바나 카오루가 프로듀서에 의해 후임으로 선발되었다. 이로써 타치바나 카오루는 아이돌의 길에서 빛나기 시작했다.\n최연소 멤버이면서도 자상하고 듬직한 성격으로 알려진 다치바나 카오루는, 봄바람을 맞는 듯한 품격을 작탁에서도 발휘하고 있다. 화료할 때 상대방에게 상처를 주지 않으려고 일부러 판수를 낮추기도 했다. 그에게 있어서 사람과 사람의 이어짐은 이기고 지는 것보다 훨씬 중요했으니까.",
    "p100": "유조",
    "p101": "보옥의 용희",
    "p102": "CV 타무라 유카리",
    "p103": "신비의 옥에서 나타난 신기한 여자아이. 기묘한 뿔과 꼬리를 갖고 있으며, 모든 것에 멍하게 대하며 무지하지만, 캡틴에 대해서 만큼은 자신의 가족이라고 단호히 말하고 있다. \n캡틴과 그녀가 함께 지은「유조」라는 이름은, 그녀를 구현화 시킨 옥과 그녀의 입에서 나온「조」를 조합한 것이다. 약간 말하기 어려워서 일까, 본인은「유쨩」이라고 부르는 쪽을 선호한다. \n유조가 캡틴에게서 떨어지려 하지 않는 것을 보고, 일번가의 경찰인 아카바네 아테나는 잠시동안 그녀를 캡틴의 감독하에 둘 것을 제안했고, 경찰이 서포트할 것을 약속했다. 캡틴이 수긍하는 것보다 빠르게, 유짱은 기뻐하는 듯한 얼굴을 했다. \n아카바네 아테나가 유조의 신원을 조사하는 동안, 캡틴은 보호자로서의 역할을 담당하고 있지만, 그녀의 성장과 변화는 캡틴이 생각한 것보다 훨씬 빠른 듯 하다...",
    "p104": "모에기하라 아오이",
    "p105": "영상신의 사자",
    "p106": "CV 나가나와 마리아",
    "p107": "영상신의 사자이자, 일발의 무녀. 사립 남풍 소학교에 다니는 모에기하라 아오이는, 일번회 설립 이래 최연소 프로 작사가 된지 얼마 되지 않았다.\n모에기하라 아오이가 지금까지 참가한 프로대회는 많지 않고, 눈에 띄는 타법 스타일도 보여주지 않고 있다. 다만 그녀는 일발과 영상개화로 화료하는 빈도가 신기할 정도로 높다.\n마치 패산을 꿰뚫어 보는 듯하다.\n학교나 마작 프로대회에 참가할 때를 제외하고, 아오이는 대부분의 시간을 영상구에 있는 이나리 신사의 무녀로 보내고 있다. 주말이나 공휴일에 신사에 참배하러 온 사람들은, 계단에 앉아 멍하니 있는 작은 모습을 볼 수 있지만, 잠시라도 눈을 떼면 그 모습은 스르르 사라져 버린다. 마치 전승 속 이나리님의 사자처럼 신기하고 현혹적으로.",
    "p108": "카자마 시즈쿠",
    "p109": "프리 스트리트",
    "p110": "CV 나가나와 마리아",
    "p111": "이익을 중시하는 어그레시브파. 위험을 즐기는 것이 일상이다. 냉정하고 차분한 얼굴 아래, 얼마나 광기 어린 아이디어가 소용돌이치고 있는지 사람들은 영원히 알지 못할 것이다.\n가령, 단지 비살상탄을 상대 보스의 이마에 맞히기 위해 스케이트 보드를 타고 옥상에서 다른 옥상으로 날아간다거나. 패산에 더 많이 남아있는 패를 버리고, 대기패가 전부 왕패에 깔려있을 가능성을 고려하지 않고 리치 지옥을 기다린다거나. 투자할 때 전망이 낮은 주식이나 기업을 선택해서 바닥을 친 후의 최대의 리턴을 얻는다...그녀는 항상 자신을 위험에 빠뜨린 후, 화려한 승리하는 것을 과시해 보인다.\n냉정해 보이는 외모와 광기 어린 행동의 대비가 인상에 남는다는 평가. 어쩌면 그녀는 위험한 행동을 하기 전에 이미 계산이 다 끝났을지도 모른다.\n혹은…그저 제정신이 아닐 뿐.",
    "p112": "엘시",
    "p113": "속죄의 시스터",
    "p114": "CV 아마미야 소라",
    "p115": "마음의 눈으로 영혼을 보는 이국의 눈가림 수녀 엘시. 풀네임은 엘스페스 캐번디시. \n오르비온의 린덴데일군 출신인 엘시는 의과대학을 졸업하고, 국제연맹 인도지원팀에 자원봉사자로 소속되어 동대륙의 남조전장으로 향한 뒤, 현지에서 난민 지원활동을 벌이고 있었다. \n반년 후, 전쟁이 종식되었으나, 그녀는 고향으로 돌아가지 않았고 의료의 길로도 나아가지 않았다. 대신, 천화시로 찾아와 북풍정의 세인트로드 대성당에서 세례를 받고 수녀가 됐다. \n그때부터 그녀는 자신의 눈을 가리고 세상을 보는 것을 거부했다. \n하지만 그것은 그녀가 프로작사가 되는 데 영향을 주지 않았다. 작탁 위에서는 패읽기 장치 없이도 국면을 파악하여 급소를 찌르는 한 수를 칠 수 있다. 어둠 속에서 헤매지 않고 오히려 더 명확하게 보이게 된 듯 하다.",
    "p116": "키사라기 리사",
    "p117": "귀신을 베는 소녀",
    "p118": "CV 아마미야 소라",
    "p119": "극동에서 천화시로 전학 온 수수께끼의 소녀로 주목을 끄는 청초계 모델. \n수앵학원의 교문에 들어선 그 순간부터 키사라기 리사는 학원 익명 사이트의 인기인이 되었다. 얼마 지나지 않아 한 여교사의 열성적인 권유로 리사는 미술부에 들어가 정식으로 미술 모델이 됐다. 이에 따라 원래 조용했던 미술부는 순식간에 인기 동아리가 됐다. 또한『스타 패션』최신호가 발매되자 누군가가 표지에 멋스러운 옷을 입은 리사의 사진을 발견했다. 스타클럽도 곧바로 정식으로 키사라기 리사의 가입을 공표했다. \n남들이 보기에 고교생 키사라기 리사의 인생은 로켓을 타는 듯 엄청난 속도로 비약하고 있다. 그러나 그녀에 관한 여러 가지 일들은 아직도 수수께끼에 싸여 있다. 그녀는 항상 해질녘이 되면 사라지고, 어디에 살고 있는지도 모르고, 친구도 없는 것 같으며 그녀에게 다가간 사람은 한기마저 느낀다고 한다……",
    "p120": "레이제이 에메코",
    "p121": "완전 귀여운 메카바니",
    "p122": "CV 사사키 히토미",
    "p123": "천재 프로그래머 소녀. 무표정의 「기계토끼」. \n작사가 되기 전, 레이제이 에메코는 선진기술 개발기업인 텐미야 그룹에서 최연소 천재 프로그래머로 전 세계적으로 유명했다. 또래들이 아직도 학교 수학 문제로 어려움을 겪고 있을 때 그녀는 이미 세계 최첨단 기술 프로젝트에서 주력 개발팀의 일원이 되어 있었다. \n몇 년 후 천화시에 파견되어 DAWN 그룹 산하 영원생명 제약회사와의 프로젝트에 협력했다. 프로젝트의 기밀성이 높기 때문에 대외적으로는 구체적인 연구 내용이 분명하지 않지만, 두 조직의 협력은 여전히 많은 흥미와 주목을 끌었다. \n여가 중에 레이제이 에메코는 작사로 활동을 시작하여 서서히 천재라는 베일을 벗고 일반인 앞에 모습을 드러냈다. 하지만 그녀가 나중에 보여준 개성은 사람들을 놀라게 하고 있다...",
    "p124": "모리 루카",
    "p125": "악마의 수안",
    "p126": "CV 야마키 안나",
    "p127": "고지 공화국의 군사부대 「장미의 검」에 소속된 군인. 휴가 명목으로 천화시에서 활동하며, 그 초과학적인 기계 오른팔이 사람에게 잊기 어려운 인상을 준다. \n팀 Dawn 운명기사에의 가입 후, 모리 루카는 리그전에서 경이적인 실력을 보여주었다. 냉혹하고 용서 없는 추격을 특기로 하는 타법으로, 작사와 관객들로부터 「악마의 팔」이라 불리우게 되었다. \n대전 중, 그녀는 자세하게 대전상대를 관찰하고, 정신적으로 큰 프레셔를 가한다. 밀려드는 불만과 거듭되는 경고 끝에, 모리 루카는 사죄와 함께 어느 정도 자숙하는 자세를 갖게 되었다. 그럼에도 그녀는, 당연하다는 듯이 「가장 상대하고 싶지 않은 작사 랭킹」 상위에 들어가 있다."
  },
  "news": {
    "p2": "전체",
    "p3": "공지",
    "p4": "점검",
    "p5": "업데이트",
    "p6": "이벤트",
    "p7": "이벤트「SUMMER LIVE」개최!",
    "p8": "마작일번가에서 6월 30일부터 기간한정 이벤트 「SUMMER LIVE」의 개최 및, 신작사 「아카바네 아테나(CV:이시카와 유이)」&「사오토메 유리카(CV:이시카와 유이)」의 등장이 결정되었습니다.",
    "p9": "게다가 잇시키 세이비 (CV:오구라 유이)、미야케 칸나(CV:아라이 사토미) 및 신작사 2명의 수영복 의상도 등장합니다!\n꼭 이벤트에 참가하시어, 퀘스트를 달성하여 호화 보상을 획득하세요!",
    "p10": "【개최 개요】 \n■개최 기간\n6/30(목)〜 7/29(금)23:59",
    "p11": "■업데이트 내용\n1. 신작사 「아카바네 아테나」&「사오토메 유리카」의 입수 확률UP!\n가챠에서는 신작사 「아카바네 아테나(CV:이시카와 유이)」&「사오토메 유리카(CV:이시카와 유이)」 및 한정 장식품의 입수 확률이 UP 됩니다.\n2. 일번가 작사(캐릭 4명)의 인기 총선거를 실시합니다.\n기간 내, LIVE 퀘스트를 클리어하는 것으로 응원 선물을 입수할 수 있습니다. 좋아하는 스트리머(캐릭터)에게 선물을 주면 더욱 풍성한 보수를 획득할 수 있습니다!\n3. 초회 가챠 2배 보너스를 리셋합니다.\n각 가격대의 초회 가챠 2배 보너스가 리셋됩니다!\n4. 편의점에서 팩 세트 판매가 추가됩니다.\n\n■신작사 등장",
    "p12": "■수영복 의상",
    "p13": "※이벤트 기간 중, 퀘스트를 클리어하면 특별한 아이템을 얻을 수 있으므로, 기대해주세요!",
    "p14": "◆다운로드는 여기에서",
    "p15": "・iOS판: {link}",
    "p16": "・Android판: {link}",
    "p17": "・PC版판: {link}",
    "p18": "◆게임에 관한 최신 정보는 공식Twitter, 공식 사이트에 갱신됩니다.",
    "p19": "◆문의사항은 여기에서",
    "p20": "이벤트「타오르는 투기장」개최!",
    "p21": "9월 26일에는 이벤트 「타오르는 투기장」과 신 캐릭터 2명이 마작일번가에 등장합니다.  \n꼭 이벤트에 참가하시어, 퀘스트를 달성하여 호화 보상을 획득하세요!",
    "p22": "■「타오르는 투기장～지하 최강 복서～」이벤트 \n이벤트 기간：9월 26일 업데이트 후～10월 15일 23:59 \n한정칭호, 아이콘 프레임, 작탁배경과 마작패를 획득하자!",
    "p23": "■신작사 등장：나츠우미 마린、사오토메 나오야 \n확률UP 기간：9월 26일 업데이트 후～10월 18일 23:59",
    "p24": "■「캡틴, 전원집합!」이벤트 \n역대 가장 뜨거운 스테이지가 당신을 기다리고 있습니다! \n이벤트 기간：9월 26일",
    "p25": "■한정의상복각! \nSteam판 릴리스의 추가기념으로, 게임 내 편의점에서 과거에 등장했던 작사의상이 기간한정으로 복각판매결정! 이번 기회를 놓치지 마세요! \n◆토호 나기・바니걸 \n◆아마미 시오츠키・과자걸 \n판매기간：9월 26일 업데이트 후～10/15（토）23:59",
    "p26": "・Steam: {link}",
    "p27": "App Store의 평가개정에 동반한 대응에 대하여",
    "p30": "App Store의 평가개정에 동반하여, 마작일번가는 모든 플랫폼（iOS판、Android판、PC판、Steam판、Apk판）에서 게임 내 일부 상품의 판매가격 개정을 시행합니다.",
    "p31": "가격개정의 세부사항은 아래에 아래 그림을 참조해주세요.",
    "p32": "（가격개정에 의해, 일부 상품의 가격은 저렴하게 됩니다.）",
    "p33": "가격개정일：2022년 10월 5일（수）",
    "p34": "【주의사항】",
    "p35": "・가격개정 후- 10월 18일 23:59, 각 가격대의 초회 충전 2배 이외, 차회 충전도 추가 20% 보너스를 얻을 수 있습니다.",
    "p36": "・가격개정 전후로, 게임 내 가격표기와 각 스토어에 있어서의 가격표기가 일시적으로 상이한 현상이 발생하는 경우가 있습니다.구입하실 때 반드시 가격표기의 확인을 부탁드립니다.",
    "p37": "・이용환경이나 단말기에 의해서는, 가격변경 설정이 반영되기까지의 시간이 상이한 경우가 있습니다.",
    "p38": "・가격변경 전에 구입한 아이템은, 가격변경 후에도 이용할 수 있습니다.",
    "p39": "・PC판과 APK판에는 60일번권의 메뉴가 없습니다.",
    "p40": " ",
    "p43": "「스트리머 크리스마스 대작전」이벤트 초대장",
    "p44": "크리스마스를 맞이함과 함께, 마작일번가2.0도 릴리스 예정으로 되었습니다.\n마작일번가2.0 릴리스기념으로 마작일번가는 전세계 스트리머가 참가할 수 있는 크리스마스 이벤트를 개최합니다!\n\n또한, 이벤트 기간 중, 마작일번가의 공식 앰배서더 : 미즈하라 아키나 프로, 마츠모토 요시히로 프로, M리거 : 나카바야시 케이 프로, Vtuber：千羽黒乃、鴨神にゅう、白雪レイド 등 100명 이상의 스트리머와 대국할 수 있는 챤스가 있습니다!\n세부사항은 이미지를 봐주세요！"
  },
  "tour": {
    "p2": "공식대회",
    "p10": "【공식대회】천하제일작투회",
    "p11": "마작일번가 공식대회「천하제일작투회」의 개최가 결정되었습니다!\n\n참가자격은 2023년 7월 21일(금) 00：00시의 시점에 4마등급「7단이상」입니다.\n\n7월 24일(월)~7월 26일(수), 매일 19시~24시에 걸쳐 예선을 진행하며 7월 27일(목) 19시~22시에 베스트 16의 준결승전을 실시, 7월 28일(금) 19시~22시에 베스트 4의 결승전 실시. 7월 28일(금) 결승전에서는 공식 스트리밍을 진행할 예정입니다. \n\n【참가자격】\n2023년 7월 21일(금) 00：00시점에 게임 내 4마등급「7단～천하일번」인 플레이어\n\n【참가방법】\n대회개최기간 중, 대회참가 자격자는 하기의 대회실 ID로 참가 가능합니다.\n・「예선」실 ID：6597939\n・「준결승」실 ID：3220100\n・「결승전」실 ID：8973769\n\n【개최기간】\n・예선：2023년 7월 24일(월)～7월 26일(수) 매일 19시~24시\n・준결승：2023년 7월 27일(목) 19시~22시\n・결승전：2023년 7월 28일(금) 19시~22시\n\n【대회 경기 룰】\n・4인마작\n・반장전\n・장고시간：5+20초\n・25000점 소지・30000점 갚기(오카없음).\n・1위에 필요한 점수：30000（서입 있음. 탑인 자가 3만점을 넘은 시점에서 종료）\n・순위점：+30、+10、-10、-30\n・적 3장, 일발, 뒷도라, 깡도라 있음.\n・쿠이땅, 아토즈케 있음.\n・도중유국 있음(9종9패, 4풍연타, 사깡유국, 삼가화, 사가리치).\n・텐파이 연짱 있음.\n・토비종료：있음.\n・오라스 오야가 탑인 경우 화료종국, 텐파이 종국이 됨.\n・동점은 첫 오야에 가까운 쪽을 우선.\n・위치 결정과 오야 결정은 게임 측에서 결정됩니다.\n\n【예선 시스템】\n・랜덤대전에서 개최기간 중 연속 5전의 합계 스코어 상위 16명이 준결승에 진출(시간 내에 몇 회라도 대국 가능. 그 중에 연속 5전의 합계 최고 스코어를 채용).\n・기간：2023년 7월 24일(월)～7월 26일(수) 매일 19시~24시\n\n【준결승 시스템】\n・동일 플레이어가 반장전 연속 5회를 시행하여, 각 탁의 4전 토탈 스코어 상위 1명이 결승전에 진출.\n・베스트 16→베스트 4가 되어, 승리하여 진출한 4명이 결승전을 치루게 됩니다.\n・기간：2023년 7월 27일(목) 19시~22시\n\n【결승전 시스템】\n・베스트 4가 대회실에서 반장전 4회 대전. 4전 토탈 스코어에 의해 우승자를 결정합니다.\n・기간：2023년 7월 28일(금) 19시~22시\n・공식 스트리밍 실시예정\n\n【부정행위에 관하여】\n・부정하게 승패를 조작하는 행위, 짜고치기 행위를 한 경우, 그 대국은 무효로 되며 본 대회실격 및 영구적으로 마작일번가의 공식대회에 참가금지 처분을 받게 됩니다. 다만 종료한 대국결과는 무효로 되지 않습니다.\n・부정행위의 판정은, 마작일번가 운영팀이나 주식회사 ACE의 심판에 의해 진행됩니다. 대회에 관한 부정행위가 보고 또는 검출된 경우, 엄청한 체크를 행한 후 공식으로부터 대책을 시행합니다.\n\n【지각・결석행위에 관하여】\n・베스트 16 이후, 예선통과자가「참가할 수 없다.」라는 뜻을【7월 27일(목) 00:00까지】{link}에 전달한 경우, 자격은 예선 포인트 랭킹에 의해 다음 순위자를 앞당겨 선정하는 것으로 합니다.\n・베스트 16 이후, 사전연락없이 개시시각으로부터【5분】이 지나도 대전에 참여하지 않고, 연락도 되지 않는 경우에는 실격처리가 되며 게임의 운영담당이 대신하여 입장합니다. 담당자는 진출을 목적으로 게임에 임합니다. 미리 양해바랍니다.\n\n【상품】\n・우승：우승 트로피 x1, 월간 마스코트(180일), 작권x50, Amazon기프트 카드 5만엔, 한정칭호「작투천하」일년간 사용권한\n・준우승：월간 마스코트(30일), 작권x30, Amazon기프트 카드 3만엔\n・3위：월간 마스코트(30일), 작권x20, Amazon기프트 카드 2만엔\n・4위：월간 마스코트(30일), 작권x10, Amazon기프트 카드 1만엔\n・5~16위：월간 마스코트(30일), 작권x5\n・역만상：대국 중 나온 역만 1회에 대하여, 작권 1장을 선물."
  },
  "special": {
    "p2": "스페셜",
    "p3": "【스탬프】「텐미야 켄이치」스탬프 배포",
    "p4": "텐미야 켄이치（CV：모리시마 슈타）",
    "p5": "【스탬프】「쟝마루」스탬프 배포",
    "p6": "쟝마루 (CV 모리시마 슈타)",
    "p7": "【스탬프】「이가라시 사에코」스탬프 배포",
    "p8": "이가라시 사에코 (CV 하세가와 레나)",
    "p9": "【스탬프】「아마미 시오츠키」스탬프 배포",
    "p10": "아마미 시오츠키 (CV 하세가와 레나)",
    "p11": "【스탬프】「쿠키 렌신」스탬프 배포",
    "p12": "쿠키 렌신 (CV 아라이 사토미)",
    "p13": "【스탬프】「잇시키 세이비」스탬프 배포",
    "p14": "잇시키 세이비 (CV 오구라 유이)",
    "p15": "【스탬프】「미야케 칸나」스탬프 배포",
    "p16": "미야케 칸나 (CV 아라이 사토미)",
    "p17": "【스탬프】「토호 나기」스탬프 배포",
    "p18": "토호 나기 (CV 오구라 유이)",
    "p19": "친애하는 캡틴 님：",
    "p20": "「마작일번가」캠페인 사무국 입니다!\n\n이번에 신 작사 등장을 기념하여 캐릭터 스탬프를 배포합니다!",
    "p21": "등장 캐릭터：",
    "p22": "팍팍 써주세요~!",
    "p23": "▼저장 방법",
    "p24": "【스마트폰】이미지를 길게 누르세요",
    "p25": "【PC】이미지를 클릭",
    "p26": "【일괄 다운로드】는 {here} 클릭",
    "p27": "▼스탬프",
    "p28": "여기를",
    "p29": "【스탬프】「아카바네 아테나」스탬프 배포",
    "p30": "아카바네 아테나 (CV 이시카와 유이)",
    "p31": "【스탬프】「사오토메 유리카」스탬프 배포",
    "p32": "사오토메 유리카 (CV 이시카와 유이)",
    "p33": "【아이콘】캐릭터 아이콘 배포",
    "p34": "「마작일번가」캠페인 사무국 입니다!\n\n이번에는 마작일번가 릴리스 반년째를 기념하여 캐릭터 아이콘을 배포합니다!\n\n팍팍 써주세요~!",
    "p35": "\n【헤더】Twitter 헤더 배포",
    "p36": "「마작일번가」캠페인 사무국 입니다!\n\n이번에는 마작일번가 릴리스 반년째를 기념하여 Twitter 헤더를 배포합니다!\n\n팍팍 써주세요~!\n",
    "p37": "▼아이콘",
    "p38": "【스마트폰】이미지를 길게 누르세요",
    "p39": "【PC】이미지를 클릭",
    "p40": "【스마트폰】이미지를 길게 누르세요",
    "p41": "【PC】이미지를 클릭",
    "p42": "▼이미지",
    "p43": "【스탬프】「나츠우미 마린」스탬프 배포",
    "p44": "나츠우미 마린 (CV:스구타 히나)",
    "p45": "【스탬프】「사오토메 나오야」스탬프 배포",
    "p46": "사오토메 나오야 (CV 나미카와 다이스케)",
    "p47": "【스탬프】「후카세 아리스」스탬프 배포",
    "p48": "후카세 아리스 (CV:누마쿠라 마나미)",
    "p49": "【스탬프】「메니야」스탬프 배포",
    "p50": "메니야 (CV:유우키 아오이)",
    "p51": "【스탬프】「AU.RO.RA」스탬프 배포",
    "p52": "메니야 (CV:오오니시 사오리)",
    "p53": "【스탬프】「시라하 아스카」스탬프 배포",
    "p54": "【스탬프】「후지 잇키」스탬프 배포",
    "p55": "시라하 아스카 (CV：우치다 마아야)",
    "p56": "메니야 (CV：스기야마 노리아키)",
    "p57": "【스탬프】「하라 미치유키」스탬프 배포",
    "p58": "하라 미치유키 (CV：유카나)",
    "p59": "【스탬프】「오토나시 이쿠코」스탬프 배포",
    "p60": "오토나시 이쿠코 (CV：유카나)",
    "p61": "【스탬프】「에노미야 미오」스탬프 배포",
    "p62": "에노미야 미오 (CV：유우키 아오이)",
    "p63": "【스탬프】「코쿠라 카나데」스탬프 배포",
    "p64": "코쿠라 카나데 (CV：스구타 히나)",
    "p65": "【스탬프】「후와 마히루」스탬프 배포",
    "p66": "후와 마히루 (CV：나츠요시 유우코)",
    "p67": "【스탬프】「이누카이 히나」스탬프 배포",
    "p68": "이누카이 히나 (CV：나츠요시 유우코)",
    "p69": "【스탬프】「타치바나 카오루」스탬프 배포",
    "p70": "타치바나 카오루 (CV：우에무라 유우토)",
    "p71": "【스탬프】「유조」스탬프 배포",
    "p72": "유조 (CV：타무라 유카리)",
    "p73": "【스탬프】일번가 x 메모오프 콜라보",
    "p74": "「마작일번가」캠페인 사무국 입니다!\n\n마작일번가 × 메모리즈오프시리즈콜라보 의\n스탬프를 3/31(일)까지 기간한정 배포합니다!\n저장 및 사용은 자유롭게 하세요!",
    "p75": "【아이콘】일번가 x 메모오프 콜라보",
    "p76": "「마작일번가」캠페인 사무국 입니다!\n\n마작일번가 × 메모리즈오프시리즈콜라보 의\n아이콘를 3/31(일)까지 기간한정 배포합니다!\n저장 및 사용은 자유롭게 하세요!",
    "p77": "【스탬프】「모에기하라 아오이」스탬프 배포",
    "p78": "모에기하라 아오이 (CV：나가나와 마리아)",
    "p79": "【스탬프】「카자마 시즈쿠」스탬프 배포",
    "p80": "카자마 시즈쿠 (CV：나가나와 마리아)",
    "p81": "【스탬프】「엘시」스탬프 배포",
    "p82": "엘시 (CV：아마미야 소라)",
    "p83": "【스탬프】마작일번가 x 단간론파 콜라보",
    "p84": "\n「마작일번가」캠페인 사무국 입니다!\n\n마작일번가 x 단간론파 콜라보 의\n스탬프를 7/30 23:59까지 기간한정 배포합니다!\n저장 및 사용은 자유롭게 하세요!",
    "p85": "【스탬프】「키사라기 리사」스탬프 배포",
    "p86": "키사라기 리사 (CV：아마미야 소라)",
    "p87": "【스탬프】「모리 루카」스탬프 배포",
    "p88": "모리 루카 (CV：야마키 안나)",
    "p100": "「마작일번가」캠페인 사무국 입니다!\n\n이번에 신 작사 등장을 기념하여 캐릭터 스탬프를 배포합니다!"
  },
  "verify": {
    "p2": "패산 생성 방법",
    "p3": "패산 생성 방법:",
    "p4": "1, 게임 내의 패산은 완전히 랜덤하게 생성됩니다. 작위적인 배패를 선택, 특정 국면에서 패산을 조작하는 일은 일절 없습니다. 패산의 생성 코드는 아래에 공개합니다.",
    "p5": "2.「완전 랜덤」을 증명하기 위해, SHA-256 코드를 게임 내에 도입하였습니다.",
    "p6": "1）각 대국의 패산은 대응하는SHA-256 코드가 있습니다. 플레이어는 각 대국 좌측 상단의 설명으로부터, 해당 대국의SHA-256 코드를 확인 할 수 있습니다.\n2）대국 종료 후, 플레이어는 패보 내에서 해당 대국의 「패산 코드」를 확인 할 수 있습니다. SHA-256 검증사이트에서「패산 코드」를 입력하면, SHA-256 코드를 획득 할 수 있습니다. 대국 중의 SHA-256 코드와 비교하면, 완전히 일치하는 결과를 얻을 수 있습니다. 그것에 의하여, 패조작이 일절 없다는 것을 증명할 수 있습니다.",
    "p7": "【패산 코드 규칙】",
    "p8": "1）만수패：m으로 표시한다（1~9m=1~9萬、0m=적도라 5萬）\n2）통수패：p로 표시한다（1~9p=1~9筒、0p=적도라 5筒）\n3）삭수패：s로 표시한다（1~9s=1~9索、0s=적도라 5索）\n4）자패：z로 표시한다（1~7z=東、南、西、北、白、發、中）\n※패산 코드의 순번은 패산의 순번과 같습니다.",
    "p9": "【Q＆A】",
    "p10": "Q1：코드를 공개하는 이유는?",
    "p11": "1）「마작일번가」는 온라인 대전 마작으로서, 플레이어에게 공평한 환경을 확보하고, 충분히 실력을 발휘 할 수 있게하는 것을 목표로 하고 있습니다. 패산의 생성방식은 공평성에 영향을 끼치는 중요한 요소의 하나 입니다. 마작일번가는 항상 랜덤한 패산의 생성을 채용하고 있습니다만, 이번에는 그러한 것을 플레이어 여러분이 아셨으면해서, 공개하였습니다.\n2）코드를 공개하는 것으로, 전 대국의 패산은 랜덤하게 생성되어, 조작이 일절 없다는 것을 증명할 수 있습니다. 또한, SHA-256 코드는, 패산은「최초부터 최후까지」변경되지 않는다는 것을 증명할 수 있습니다.\n3）「마작일번가」는 차후,「즉시 패산 코드」（모든 배패의 각종비율을 즉시 사이트에 반영함）의 공개를 예정하고 있습니다.\n4）의견이나 희망사항이 있으시다면 riichicitysupport@mahjong-jp.com로 부담 없이 연락 바랍니다.",
    "p12": "Q2：MD5가 아니고 SHA-256 코드를 선택한 이유는?",
    "p13": "MD5는 유일하고, 불가역적인 특정이 있어서, 암호나 인증, 디지털 서명 등의 수단으로써 다양한 방면에 이용되고 있습니다.\n하지만, SHA-256 코드는 보다 더 안전한 보안 코드 입니다. 확률이 상당히 낮습니다만, MD5 코드는 충돌에 의해 공격당할 가능성이 있으므로, 그것을 피하기 위해, SHA-256 코드를 이용하였습니다.\n이것에 의해,「마작일번가」는 전력으로 유저의 안전성을 보증하고 있습니다.",
    "p14": "Q3：패산 전체의 코드를 공개하는 이유는?",
    "p15": "손패의 배포에도 조작이 없다는 것을 증명하기 위해, 손패를 포함하여 패산을 공개하고 있습니다."
  },
  "streamer": {
    "p2": "스트리머 전용",
    "p3": "스트리머 여러분, 마작일번가에 어서 오세요!",
    "p4": "▼스트리밍 소재 다운로드",
    "p5": "「마작일번가」는 스트리머 여러분을 위해 소재를 준비해두었습니다.",
    "p6": "실시간 스트리밍이나 2차 창작에서 이용 가능합니다.",
    "p7": "다운로드는 이쪽",
    "p8": "▼문의",
    "p9": "이하의 희망 사항이 있으시다면, 언제라도 연락 바랍니다.",
    "p10": "마작일번가에서 대회를 개최하고 싶은 경우(협찬을 상담하고 싶은 경우)",
    "p11": "마작일번가의 공식 인증 스트리머가 되고 싶은 경우",
    "p12": "그 외에 마작일번가에의 의견, 희망 사항, 상담하고 싶은 것이 있는 경우",
    "p13": "연락처 메일 : ",
    "p14": "앞으로도 「마작일번가」를 잘 부탁드립니다.",
    "p15": "riichicitysupport@mahjong-jp.com",
    "p16": "통상 전송 소재: 다운로드는 이쪽",
    "p17": "스타 라이브 소재: 다운로드는 이쪽",
    "p18": "강렬한 욕망의 배 소재: 다운로드는 이쪽",
    "p19": "스피드 레이서소재: 다운로드는 이쪽",
    "p20": "비색의 한여름 이벤트 소재: 다운로드는 이쪽"
  },
  "riichicitystore": {
    "p2": "로딩 중..."
  },
  "survey_bg": {
    "p2": " ",
    "p3": "「초고급」",
    "p4": "의 재능을",
    "p5": "발굴하기 위해,",
    "p6": "우리—키보가미네 학원은,\n「초고교급 진단」을 개발했다.\n꼭, 참가를 부탁하고 싶다.",
    "p7": "너는 어떤 재능을 가지고 있을까?",
    "p8": "테스트 시작",
    "p9": "다시 하기",
    "p10": "결과를 공유하기",
    "p11": "초고교급 진단",
    "p12": "초고교급",
    "p13": "다음으로",
    "p14": "언어선택",
    "p15": "진단하기",
    "p16": "다시 한번",
    "p17": "저장하기",
    "p18": "공유하기",
    "p19": "마작일번가 공식 사이트로",
    "p20": "저장완료",
    "p21": "쉐어완료",
    "p22": "그 외",
    "p23": "돌아가기",
    "p24": "WeChat",
    "p25": "Weibo",
    "p26": "Baidu Tieba",
    "p27": "진단으로",
    "p28": "『마작일번가』×『단간론파』콜라보 이벤트",
    "p30": "콜라보 이벤트「초고교급 진단」의 쉐어보상",
    "p31": "친애하는 캡틴, 「초고교급 진단」에 참가해 주셔서 감사합니다! 아래의 보상을 받아주세요!",
    "p32": "게임 내 메일로 보상이 발송되므로 메일을 확인 바랍니다.",
    "p36": "『마작일번가』×『단간론파』콜라보 이벤트의 진단결과는 ",
    "p37": "입니다! 링크를 탭하여 진단에 참가합시다!",
    "p41": "『마작일번가』콜라보 이벤트",
    "p42": "『마작일번가』콜라보 이벤트의 진단결과는 ",
    "p43": "입니다! 링크를 탭하여 진단에 참가합시다!",
    "p46": "초고교급진단",
    "p47": "일번가단간론파콜라보",
    "p48": "『마작일번가×단간론파』콜라보<초고교급 진단>",
    "p51": "이벤트가 종료되었습니다",
    "p52": " ",
    "p53": "초 후, ",
    "p54": "「마작일번가」",
    "p55": " 공식사이트로 이동됩니다"
  },
  "survey_question": {
    "p2": "노력과 운, 어느 쪽이 중요하다고 생각합니까?",
    "p3": "노력",
    "p4": "운",
    "p5": "당신은 아웃도어파입니까, 인도어파 입니까?",
    "p6": "아웃도어파",
    "p7": "인도어파",
    "p8": "혼자 지내는 것과 모두 함께 지내는 것 중 어느 쪽을 좋아합니까?",
    "p9": "혼자서",
    "p10": "다같이",
    "p11": "추리와 상상 중 어느 쪽을 좋아합니까?",
    "p12": "추리",
    "p13": "상상",
    "p14": "당신은 산을 좋아합니까 바다를 좋아합니까/",
    "p15": "산",
    "p16": "바다",
    "p17": "스피드와 파워 중 어느 쪽에 자신이 있습니까?",
    "p18": "스피드",
    "p19": "파워",
    "p20": "당신은 말하는 편인가요, 듣는 편인가요?",
    "p21": "말하는 편",
    "p22": "듣는 편",
    "p23": "모름",
    "p24": "2차원과 3차원 중 어느 쪽을 좋아하시나요?",
    "p25": "2차원",
    "p26": "3차원",
    "p27": "당신은 운이 좋습니까?",
    "p28": "강운",
    "p29": "보통",
    "p30": "당신은 이성파입니까? 아니면 감성파입니까?",
    "p31": "이성파",
    "p32": "감성파",
    "p33": "기지와 미지 중 어느 쪽을 좋아합니까?",
    "p34": "기지",
    "p35": "미지",
    "p36": "마작과 책 중 어느 쪽을 좋아합니까?",
    "p37": "마작",
    "p38": "책",
    "p39": "조용한 곳과 시끌벅적한 곳 중 어느 쪽을 좋아합니까?",
    "p40": "조용한 쪽",
    "p41": "시끌벅적한 쪽",
    "p42": "당신은 냉정파입니까, 열혈파입니까?",
    "p43": "냉정파",
    "p44": "열혈파",
    "p45": "당신은 포지티브파입니까, 네거티브파입니까?",
    "p46": "포지티브파",
    "p47": "네거티브파",
    "p48": "그래... 이런 결말, 역시 뭔가 잘못됐어.\n이대로 끝나면 절망적이라고 생각된다만?",
    "p49": "절망적",
    "p50": "초절망적"
  },
  "survey_result": {
    "p2": "초고교급 격투가",
    "p3": "너는 산처럼 온화한 사람이지만, \n유례없는 무예의 재주가 있다.\n대자연 속에서 엄격한 수행을 거듭하여\n일격필살의 오의를 습득하면,\n천인 합일을 이루리라.",
    "p4": "초고교급 수영 선수",
    "p5": "너는 물처럼 상냥하고 태양처럼 따뜻한 사람.\n항상 혼자 훈련했지만 밝은 성격으로\n집단 활동에서도 잘 해나갈 수 있다.\n믿어도 좋다. 네가 흘린 땀과 눈물은 분명 보답받을 것이다.",
    "p6": "초고교급 폭주족",
    "p7": "너는 명확한 목표가 있고, 결코 포기할 수 없는 남자 중의 남자.\n가속하는거다! 질풍과 번개가 너의 날개가 된다!\n단, 교통안전에 주의하도록.",
    "p8": "초고교급 야구 선수",
    "p9": "너는 쾌활하고 열정적인 성격이며, 누구와도 친해질 수 있다.\n뛰어난 완력과 동체시력의 소유자로 던지는 공은 미사일급.\n훈련을 계속하다 보면\n언젠가 세계적인 유명한 프로 선수가 될지도 모르겠어요.",
    "p10": "초고교급 풍기 위원",
    "p11": "너는 공정무사하고 집단을 중히 여기는 사람.\n질서는 파괴하는 것보다 유지하는 것이 훨씬 더 어렵다는 것을,\n너는 잘 이해하고 있으니까.\n그 무뚝뚝한 얼굴 아래 감춰진\n자상한 마음을 소중히 간직해 주세요.",
    "p12": "초고교급 프로그래머",
    "p13": "너는 말수는 적지만 머리회전이 빠르고 논리적인 사람.\n네가 쓴 코드는 사고의 분신이며, \n사람들에게 그 빛나는 재능을 표현하고 있다.\n좋아하는 것을 하면 좋다. 다른 사람이 좋아하는 것보다, \n자신이 좋아하는 자신으로 있는 것이 더 중요하니까.",
    "p14": "초고교급 ???",
    "p15": "너는 수수께끼 많은 인물…….\n어떤 재능을 간직하고 있는지 진단만으로는 해독할 수 없다.\n그것이야말로 너의 재능인지도 몰라.",
    "p16": "초고교급 동인 작가",
    "p17": "훌륭한 상상력과 이차원에 대한 사랑이 있네!\n부디 붓을 들어 그 상상과 사랑을 다른 사람에게 전하기 바란다.\n그것은 훌륭하고 위대한 재능이다.",
    "p18": "초고교급 문학 소녀",
    "p19": "너는 그 얼마나 재기 넘치는 소녀인가!!\n장래는 연애소설 베스트셀러 작가임에 틀림없다!!\n…뭐야? 소녀가 아니라고?\n그것은 대단히 실례. 그만 흥분해서...",
    "p20": "초고교급 갬블러",
    "p21": "네가 보여주는 표정 뒤에서, \n사실은 무엇을 생각하고 있는 것인가? 아무도 알 수 없다.\n너와 내기를 하는 것은 불운이야, \n왜냐하면 처음부터 결과는 정해져 있으니까.\n갬블에서 필승법은 존재하지 않지만 필승의 너는 있다.",
    "p22": "초고교급 도련님",
    "p23": "너는 냉혹할 정도로 이성적인 사람.\n선천적으로 압도적인 우위를 가지고 있어도\n그것을 자랑스러워하지는 않는다.\n쓴 왕관의 무게에 부디 짓눌리지 않기를 바란다.\n왕도라 불리는 가시밭길을 뒤돌아보지 않고 나아가라.",
    "p24": "초고교급 점쟁이",
    "p25": "너는 로맨티스트이고 세속적인 성공에 무관심한 사람.\n그 머리 속에는 또 하나 아름다운 밤하늘이 펼쳐져 있다.\n비록 결과를 의심받더라도 친구의 운명을 점쳐줘.",
    "p26": "초고교급 아이돌",
    "p27": "너는 사람들에게 미소를 가져다 줄 수 있는 사람이다.\n만약 프로 아이돌이 된다면 분명 거물이 될 수 있다.\n그 활기찬 퍼포먼스는 많은 사람을 사로잡을 것이다.",
    "p28": "초고교급 군인",
    "p29": "전장에서 살아남으려면 운이 필요하지만\n운 이상으로 중요한 것은 냉정이다.\n너는 뛰어난 통찰력과 냉정한 두뇌를 가지고 있다. \n위기를 신속하게 파악하고 해결할 수 있을 것이다.\n...다만, 가장 안전하다고 생각되는 장소가,\n실은 가장 위험할지도 모른다. 조심해 둬.",
    "p30": "초고교급 행운",
    "p31": "특별히 눈에 띄는 특징은 없는 것 같다.\n대부분의 보통 사람들과 마찬가지로 보통 생활을 하고 있다. \n슬퍼하거나 기뻐하거나 두려워하거나 때로는 용감해지거나. \n평범하게 매일을 보내는 것이야말로, 최대의 행운인지도 모른다.",
    "p32": "초고교급 갸루",
    "p33": "너는 패션의 달인이구나!\n거리를 걸으면 많은 주목을 받을 정도로 매력이 넘친다!\n생각지도 못한 곳에서 유명한 패션쇼에 초대받을 지도 모른다.",
    "p34": "초고교급 절망",
    "p35": "뭐? 패션쇼? 농담은 그만 좀 해줘….\n네가 세상에 가져오는 것은 그런 평범한 것이 아니야.\n그 재능은 모든 사람을 절망에 빠뜨리고,\n절망에 휩싸이고, 마지막에는 절망에 삼켜진다.\n절망을 마음껏 맛보게."
  },
  "survey_profession": {
    "p2": "격투가",
    "p3": " 수영 선수",
    "p4": " 폭주족",
    "p5": " 야구 선수",
    "p6": " 풍기 위원",
    "p7": " 프로그래머",
    "p8": "초고교급",
    "p9": " 동인 작가",
    "p10": " 문학 소녀",
    "p11": " 갬블러",
    "p12": " 도련님",
    "p13": " 점쟁이",
    "p14": " 아이돌",
    "p15": " 군인",
    "p16": " 행운",
    "p17": " 갸루",
    "p18": " 절망"
  },
  "sgtest_quest": {
    "p2": "매우 강한 중력을 가진 초고밀도의 천체는 무엇인가요?",
    "p3": "블랙홀",
    "p4": "혜성",
    "p5": "초콜렛",
    "p6": "마야인이 세계종말을 예언한 것은 몇년도인가요?",
    "p7": "2012년",
    "p8": "2024년",
    "p9": "2000년",
    "p10": "오카베 린타로가 자주 마시는 지적음료 「Dr. P」는 무엇인가요?",
    "p11": "치사량의 와사비를 넣은 미소시루",
    "p12": "독특한 맛이 나는 탄산음료",
    "p13": "마시면 졸리게 되는 탄산음료",
    "p14": "다음 중, 뱃 속 아기의 성별을 바꾸는 행위는 무엇인가요?",
    "p15": "바나나를 먹는다",
    "p16": "마작을 한다",
    "p17": "뱃 속 아기의 성별은 바꿀 수 없다",
    "p18": "그리스 문자 중, 시작을 뜻하는 문자는 무엇인가요?",
    "p19": "Ω",
    "p20": "α",
    "p21": "β",
    "p22": "끈적한 피를 발광시키는 획기적인 아이디어와, 손잡이를 붙이는 것으로 리얼한 칼싸움 놀이를 가능하게 하는 미래가젯의 이름은?",
    "p23": "모아드・스네이크",
    "p24": "사이륨・세이버",
    "p25": "비트 입자포",
    "p26": "약간의 변화를 줌으로써 매우 작은 사건이 최종적으로 예상하지도 못했던 것과 같은 큰 사건으로 이어진다는 것을 의미하는 말은 어떤 것입니까?",
    "p27": "나비효과",
    "p28": "꿀벌효과",
    "p29": "유니콘효과",
    "p30": "뇌 속에는 기억에 있어서 중요한 역할을 하는 부위가 있습니다.\n해양 생물과 닮았다고 해서 그것의 이름이 붙여졌습니다. 그 해양생물이란 무엇인가요?",
    "p31": "가시복",
    "p32": "개복치",
    "p33": "해마",
    "p34": "상대성 이론을 제창한 사람은 누구인가요?",
    "p35": "오다 노부나가",
    "p36": "호오인 쿄우마",
    "p37": "아인슈타인",
    "p38": "북구신화에 있어서, 전쟁을 관장하는 여신의 이름은 무엇인가요?",
    "p39": "발키리",
    "p40": "이자나미",
    "p41": "제우스",
    "p42": "D메일로 보내진 데이터양은 36바이트 입니다만, 전각문자로 몇 문자에 해당하나요?",
    "p43": "36",
    "p44": "12",
    "p45": "18",
    "p46": "지구에서 은하중심까지의 거리는 어느정도인가요?",
    "p47": "384399km",
    "p48": "2.6만 광년",
    "p49": "16.4광년",
    "p50": "여름의 대삼각 중에서, 직각의 정점에 있으며 칠석의 전설과 깊게 연관되어 있는 별은 어느 것입니까?",
    "p51": "베가",
    "p52": "알타이르",
    "p53": "데네브",
    "p54": "우주에서 가장 많이 존재하는 원소는 무엇인가요?",
    "p55": "수소",
    "p56": "황",
    "p57": "산소",
    "p58": "키류 모에카는 중증의 휴대폰 의존증으로 항상 폰화면을 응시하며, 타자 속도는 천하일품입니다.\n다음 중, 그녀의 닉네임으로서 올바른 것은 무엇입니까?",
    "p59": "섬광의 지압사",
    "p60": "전광석화의 뇌",
    "p61": "반짝이는 마안",
    "p62": "아마네 스즈하의 자전거 속도는 20km/h이고, 오카베 린타로의 자전거 속도는 12km/h입니다.\n그들이 16Km 떨어진 A와 B지점에서 각각 동시에 마주보고 전진하여 만났다고 가정할 시, 어느정도의 시간이 걸린 후에 만나는 것이 가능한가요?",
    "p63": "1h",
    "p64": "30min",
    "p65": "40min",
    "p66": "인기 아니메 「라이넷 카케루」에 등장하는 마스코트 캐릭터의 이름은 무엇입니까?",
    "p67": "우파",
    "p68": "오카린",
    "p69": "게로 카에룬",
    "p70": "다음 중, 오카베 린타로가 작별의 인사로써 사용하고 있는 말은 무엇입니까?",
    "p71": "엘・프사이・콩그루",
    "p72": "엘・프사이・콩가리",
    "p73": "엘・프사이・콩쿠루",
    "p74": "라보멘 배지 가장자리에는 멤버 이름의 이니셜이 새겨져 있습니다.\n다음 중 올바른 순서는 어느 것입니까?",
    "p75": "OSHMKFUA",
    "p76": "OSHMKUFA",
    "p77": "OSHKMUFA",
    "p78": "1975년에 발견되어, 오카베 린타로가 아키하바라에서 찾아다녔던 환상의 레트로PC의 이름은 무엇인가요?",
    "p79": "IBN5100",
    "p80": "IBN5110",
    "p81": "IBM5100",
    "p82": "2036년의 세계에서 온 시간여행자는 누구인가요?",
    "p83": "존・타이타",
    "p84": "루돌프・펜츠",
    "p85": "도라・아이몬",
    "p86": "마작일번가 3마 등급전 룰에 있어서, 도중유국이 되는 상황은 어떤 상황입니까?",
    "p87": "9종9패",
    "p88": "4풍연타",
    "p89": "삼가리치",
    "p90": "마작일번가 등급전 룰에 있어서, 녹일색으로 화료하기 위해 필요하지 않은 패는 무엇인가요?",
    "p91": "7삭",
    "p92": "8삭",
    "p93": "発",
    "p94": "마작일번가 등급전 룰에 있어서, 역만이 아닌 것은 무엇인가요?",
    "p95": "사암각",
    "p96": "구련보등",
    "p97": "청일색"
  },
  "sgtest_bg": {
    "p2": "아쉽게도 운명은 네 녀석을 선택하지 않은 것 같다…재도전을 기다리겠다.",
    "p3": "네 녀석은 라보멘으로서의 자격을 얻었다. 하지만, 이것으로 만족하지마라. 진정한 시련은 이제부터다.",
    "p4": "어둠의 힘에 이끌린 자여, 여기에 모여 운명을 받아들여라!",
    "p5": "여기서부터 네놈은 운명의 공범자다! 각오는 되었는가?",
    "p6": "어서오세요, 미래 가젯 연구소에! 세계의 진리를 파헤치고, 함께 어둠 속을 전진하자!",
    "p7": "공부해서 한번 더 도전했으면 하는데. 마유시가 응원할테니까. 응?",
    "p8": "해냈네-! 그래도 그래도, 좀 더 점수가 오르는 것도 보고싶네.",
    "p9": "대단-해! 정말 놀라워. 앞으로도 라보멘으로서 함께 노력하자!",
    "p10": "이런 결과는 처음 봤어-. 엣헤헤, 지고 있을 수는 없지-.",
    "p11": "마유시는 지금 매우 감동하고 있어! 축하해!",
    "p12": "기초가 부실하네. 다음에는 좀 더 준비해서 도전해 봐.",
    "p13": "뭐, 합격이네. 그래도 만족해 하지마. 아직 성장 잠재력이 있으니까.",
    "p14": "축하해. 당신의 실력은 틀림없는 것 같네.",
    "p15": "흠. 이 결과는 훌륭하네. 자신을 가져도 좋다고 생각해.",
    "p16": "100점 얻을 확률은 5%의 확률 밖에 안돼. 자신에게 자부심을 가져도 돼.",
    "p17": "포기하지 않으면 어떻게든 돼! 다음에는 분발하자!",
    "p18": "이걸로 합격이긴 하지만, 아직 싸움은 계속되니까!",
    "p19": "잘하네-. 이! 전사로서의 실력이 보여져 버렸네.",
    "p20": "이런 높은 점수를 얻다니 너를 존경해버리게 돼!",
    "p21": "대단해! 너는 나와 같이 어엿한 전사네!",
    "p30": "다운로드 특전",
    "p31": "라보멘 적성 테스트",
    "p32": "우리 미래 가젯 연구소에서는 마작일번가에 임시지부를 설치하여, 기관과의 최종성전에 대비해 함께 싸울 동료를 모집하고 있다.\n능력적합자에게는 이 호오인 쿄우마가 피의 맹약을 내려주겠다.",
    "p33": "입수조건 : ",
    "p34": "적성 테스트     <span style=\"color: #3c3a43\">60</span>\n점 이상.",
    "p35": "하기",
    "p36": "버리기",
    "p37": "어, 어이! 이 절호의 찬스를 지나칠 셈인가!?\n이 광기의 매드 사이언티스트, 호우인 쿄우마의 동료가 될 수 있다고?",
    "p38": "어쩔 수 없네.",
    "p39": "이벤트가 종료되었습니다.\n「마작일번가」 공식 사이트로 3초 후에 자동으로 이동됩니다.",
    "p40": "이름",
    "p41": "테스트하기",
    "p42": "다음",
    "p43": "종료하기",
    "p44": "득점",
    "p45": "아깝네…다음에는 분발하자!",
    "p46": "합격 축하해! 라보멘",
    "p47": "한번 더",
    "p48": "저장하기",
    "p49": "쉐어하기",
    "p50": "보상이 배포되었습니다. 게임 내 메일에서 확인해 주세요~",
    "p51": "쉐어하면 마작패를 획득\n",
    "p52": "닉네임에 부적절한 문자열이 포함되어 있습니다.",
    "p53": "8자 이내로 입력해 주세요(영문 글자는 16자 이내)",
    "p54": "닉네임을 입력해 주세요.",
    "p55": "8자 이내의 닉네임 입력",
    "p56": "1개 이상의 선택지를 입력해 주세요~",
    "p57": "저장완료",
    "p58": "일번가슈타게콜라보",
    "p59": "마작일번가",
    "p60": "슈타게",
    "p61": "「마작일번가×슈타인즈・게이트 콜라보」 기간한정 이벤트＜라보멘 적성 테스트＞"
  }
}